// extracted by mini-css-extract-plugin
export default {"cartIcon":"style_cartIcon__upV3g","cartCount":"style_cartCount__EGABa"};